// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import AgendaItemElement from "./agenda-item-element.js"
import Contact from "./contact.js"

const modelClassData = {
  "attributes": {
    "agenda_item_element_id": {
      "column": {
        "default": null,
        "name": "agenda_item_element_id",
        "null": false,
        "type": "uuid"
      },
      "name": "agenda_item_element_id",
      "selected_by_default": null,
      "translated": null
    },
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "done_speaking": {
      "column": {
        "default": false,
        "name": "done_speaking",
        "null": false,
        "type": "boolean"
      },
      "name": "done_speaking",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "initial_time": {
      "column": {
        "default": "00:03:00",
        "name": "initial_time",
        "null": false,
        "type": "time"
      },
      "name": "initial_time",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "timer_started_at": {
      "column": {
        "default": null,
        "name": "timer_started_at",
        "null": true,
        "type": "datetime"
      },
      "name": "timer_started_at",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "AgendaItemElementSpeaker",
  "collectionKey": "agenda_item_element_speakers",
  "collectionName": "agenda_item_element_speakers",
  "i18nKey": "agenda_item_element_speaker",
  "camelizedLower": "agendaItemElementSpeaker",
  "name": "AgendaItemElementSpeaker",
  "nameDasherized": "agenda-item-element-speaker",
  "pluralName": "agenda_item_element_speakers",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "has_one",
      "resource_name": "Activity",
      "through": "agenda"
    },
    {
      "className": "Agenda",
      "collectionName": "agendas",
      "foreignKey": "agenda_id",
      "name": "agenda",
      "macro": "has_one",
      "resource_name": "Agenda",
      "through": "agenda_item"
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "agenda_item_id",
      "name": "agenda_item",
      "macro": "has_one",
      "resource_name": "AgendaItem",
      "through": "agenda_item_element"
    },
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "agenda_item_element_id",
      "name": "agenda_item_element",
      "macro": "belongs_to",
      "resource_name": "AgendaItemElement",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "agenda_item_element_id",
      "column": {
        "default": null,
        "name": "agenda_item_element_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "done_speaking",
      "column": {
        "default": false,
        "name": "done_speaking",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "initial_time",
      "column": {
        "default": "00:03:00",
        "name": "initial_time",
        "null": false,
        "type": "time"
      }
    },
    {
      "name": "old_agenda_item_element_id",
      "column": {
        "default": null,
        "name": "old_agenda_item_element_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "timer_started_at",
      "column": {
        "default": null,
        "name": "timer_started_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "agenda_item_element_id",
      "name": "agenda_item_element",
      "macro": "belongs_to",
      "resource_name": "AgendaItemElement",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "agenda_item_element_speaker",
  "primaryKey": "id"
}

/** Frontend model for AgendaItemElementSpeaker. */
export default class AgendaItemElementSpeaker extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  agendaItemElementId() {
    return this.readAttributeUnderscore("agenda_item_element_id")
  }

  /** @returns {boolean} */
  hasAgendaItemElementId() {
    const value = this.agendaItemElementId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  doneSpeaking() {
    return this.readAttributeUnderscore("done_speaking")
  }

  /** @returns {boolean} */
  hasDoneSpeaking() {
    const value = this.doneSpeaking()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  initialTime() {
    return this.readAttributeUnderscore("initial_time")
  }

  /** @returns {boolean} */
  hasInitialTime() {
    const value = this.initialTime()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  timerStartedAt() {
    return this.readAttributeUnderscore("timer_started_at")
  }

  /** @returns {boolean} */
  hasTimerStartedAt() {
    const value = this.timerStartedAt()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  startTimer(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "start_timer",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_element_speakers",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  stopTimer(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "stop_timer",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_element_speakers",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./agenda-item-element.js").default | null} */
  agendaItemElement() {
    return this._readBelongsToReflection({modelClass: AgendaItemElement, reflectionName: "agenda_item_element"})
  }

  /** @returns {Promise<import("./agenda-item-element.js").default | null>} */
  loadAgendaItemElement() {
    if (!("agendaItemElementId" in this)) throw new Error("Foreign key method wasn't defined: agendaItemElementId")

    const id = this.agendaItemElementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "agenda_item_element",
        model: this,
        modelClass: AgendaItemElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./agenda-item-element.js").default | null>} */
  ensureAgendaItemElementLoaded() {
    return this.ensureAssociationLoaded("agenda_item_element")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }
}
